import { createPortal } from 'react-dom';
import { AppStoreBadges } from './AppStoreBadges';

const BETA_EMAIL = 'beta@storychain.fun';

interface BetaModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BetaModal: React.FC<BetaModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center mb-4">
          <span className="text-5xl">🚀</span>
        </div>
        <h3 className="text-xl font-bold text-center text-gray-900 mb-2">
          Get the App
        </h3>
        <p className="text-gray-600 text-center mb-6">
          StoryChain is available on the App Store and Google Play:
        </p>
        <AppStoreBadges layout="stack" className="mb-4" />
        <p className="text-xs text-gray-500 text-center mb-4">
          Need help? Email{' '}
          <a href={`mailto:${BETA_EMAIL}`} className="text-primary-600 hover:underline">
            {BETA_EMAIL}
          </a>
        </p>
        <button
          onClick={onClose}
          className="w-full bg-gray-100 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-200 transition"
        >
          Close
        </button>
      </div>
    </div>,
    document.body
  );
};
